import { Link } from '@tanstack/react-router';
import { Button } from '@/shared/components/ui/button';
import lightImg1 from '@/assets/light-theme/404_1.png';
import lightImg2 from '@/assets/light-theme/404_2.png';
import lightImg3 from '@/assets/light-theme/404_3.png';
import lightImg4 from '@/assets/light-theme/404_4.png';
import darkImg1 from '@/assets/dark-theme/404_1.png';
import darkImg2 from '@/assets/dark-theme/404_2.png';
import darkImg3 from '@/assets/dark-theme/404_3.png';
import darkImg4 from '@/assets/dark-theme/404_4.png';
import { useMemo, useEffect } from 'react';
import { useTheme } from '@/shared/providers/ThemeProvider';

const lightImages = [lightImg1, lightImg2, lightImg3, lightImg4];
const darkImages = [darkImg1, darkImg2, darkImg3, darkImg4];

export const NotFound = () => {
  const { isDark } = useTheme();

  useEffect(() => {
    document.title = '404 - Page Not Found | RobinHoot';
    return () => {
      document.title = 'RobinHoot';
    };
  }, []);

  const randomIndex = useMemo(() => Math.floor(Math.random() * lightImages.length), []);
  const randomImage = isDark ? darkImages[randomIndex] : lightImages[randomIndex];

  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] p-4 text-center space-y-8 animate-in fade-in zoom-in duration-500">
      <div className="w-full max-w-md relative">
        <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-secondary/20 rounded-full blur-3xl opacity-30 -z-10" />
        <img
          src={randomImage}
          alt="404 - Page Not Found"
          className="w-full h-100 object-contain drop-shadow-xl"
        />
      </div>
      <div className="space-y-4 max-w-lg">
        <h1 className="text-4xl font-extrabold tracking-tight lg:text-5xl text-primary">
          Oops! Page Not Found
        </h1>
        <p className="text-muted-foreground text-lg">
          It looks like the page you&apos;re looking for has wandered off into the void. Don&apos;t
          worry, even the best explorers get lost sometimes.
        </p>
      </div>
      <div className="flex gap-4">
        <Button
          asChild
          size="lg"
          className="font-semibold shadow-lg hover:shadow-xl transition-all"
        >
          <Link
            to="/booking"
            search={{
              resourceId: undefined,
              officeId: undefined,
              date: undefined,
              startTime: undefined,
              endTime: undefined,
            }}
          >
            Take Me Home
          </Link>
        </Button>
        <Button asChild variant="outline" size="lg" onClick={() => window.history.back()}>
          <button>Go Back</button>
        </Button>
      </div>
    </div>
  );
};
